import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  FunctionFormSchema,
  getFunctionFormSchema as universalGetFunctionFormSchema,
} from './functions-v1-function-form-schema-function-form-schemas.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/functions' };

/** @internal */
export function getFunctionFormSchema(
  httpClient: HttpClient
): GetFunctionFormSchemaSignature {
  return (functionId: string) =>
    universalGetFunctionFormSchema(
      functionId,
      // @ts-ignore
      { httpClient }
    );
}

interface GetFunctionFormSchemaSignature {
  /**
   * Retrieves a FunctionFormSchema.
   * @param - ID of the function of the returned FunctionFormSchema.
   * @returns The requested FunctionFormSchema.
   */
  (functionId: string): Promise<
    NonNullablePaths<
      FunctionFormSchema,
      `formFieldSources` | `formFieldSources.${number}.formFieldSourceType`,
      2
    >
  >;
}

export {
  FormFieldSource,
  FormFieldSourceType,
  FunctionFormSchema,
  GetFunctionFormSchemaRequest,
  GetFunctionFormSchemaResponse,
} from './functions-v1-function-form-schema-function-form-schemas.universal.js';
